<template>
  <cui-workspace-types-filter
    :model-value="modelValue"
    :items="items"
    :disabled="disabled"
    :placeholder="$t('manageWorkspaces.filters.type')"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #item-title="{ item }">
      {{ $t(`manageWorkspaces.workspaceTypes.${item.title}`) }}
    </template>
  </cui-workspace-types-filter>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { CuiWorkspaceTypesFilter } from "@coronet/cui";
import type { WorkspaceType } from "@/constants/workplaces";

/**
 * Workspace "Type" (Channel / Child / Regular) multi-select filter.
 * Thin wrapper over `@coronet/cui`'s `CuiWorkspaceTypesFilter`: keeps the local `v-model` + `items`
 * API (call sites untouched) and supplies the translated placeholder + per-item labels, since the
 * library component is i18n-agnostic.
 */
export default defineComponent({
  components: { CuiWorkspaceTypesFilter },
  props: {
    /** Selected workspace types (v-model). */
    modelValue: {
      type: Array as PropType<WorkspaceType[]>,
      required: true,
    },
    /** Available workspace types to render. */
    items: {
      type: Array as PropType<WorkspaceType[]>,
      required: true,
    },
    /** Disables the select. */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
});
</script>
